import { render, staticRenderFns } from "./CVideoNew.vue?vue&type=template&id=3956a1cd&"
import script from "./CVideoNew.vue?vue&type=script&lang=js&"
export * from "./CVideoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports